export const approveTopupV2 = {
    approveTopupV2: 'Approve TopUp V2',
    approveTopup: 'Approve TopUp',
    username: 'Username',
    paymentName: 'PaymentName',
    refCode1: 'Ref Code 1',
    status: 'Status',
    transactionId: 'Transaction ID',
    refCode3: 'Ref Code 3',
    createdAt: 'Created At',
    advanceFilter: 'Advance Filter',
    approve: 'Approve',
    reject: 'Reject',
    remark: 'Remark',
    date: 'Date',
    depositDate: 'Deposit Date',
    amount: 'Amount',
    accountId: 'AccountId',
    txnRemark: 'TxnRemark',
    rejectTopupTitle: 'Reject TopUp',
    approveTopupTitle: 'Approve Topup',
    note: 'Note',
    userCode: 'Phone number',
    bankAccountName: "Bank Account Name",
    bankAccountNumber: "Bank Account Number",
    confirmTopup: "Confirm Topup",
    transactionDate: 'Transaction Date',
    bankAccountOwnerNumber: "Bank Account Owner Number",
    operator: "Operator",
    bank: "Bank",
    bankAccount: "Bank Account",
    assignUserTopup: "Assigning User Topup",
    assignOperatorTopup: "Assigning Operator Topup",
    bankName: "Bank Name",
    bankNo: "Bank No",
    createdDate: "Created Date"
}
